// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"c57d3c6a","80":"30ea4538","815":"c57d3c6a"}[chunkId] + ".chunk.css";
};